<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="showUserAuthentication || showUserDocumentation ? 'd-none' : ''"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- mobile -->
        <td>
          <td-value copyToClipboard [value]="item?.mobile"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value type="dateTime" [value]="item?.expireDate"></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!--show organization documentation btn-->
          <a
            *ngIf="item.id == permissionService.userState()?.userId"
            (click)="onShowDocumentations(item?.id)"
            class="btn btn-sm tw-mx-1"
            [matTooltip]="'common.documentation' | translate"
          >
            <i class="mdi mdi-folder-account-outline mdi-20px text-info"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- authentication form -->
<ng-container *ngIf="showUserAuthentication">
  <app-user-authentication-form (closeFormPage)="onCloseAuthorization()">
  </app-user-authentication-form>
</ng-container>

<!--user documentation -->
<ng-container *ngIf="showUserDocumentation">
  <app-user-documentation-form
    [userId]="userId"
    (closeFormPage)="onCloseDocumentation()"
  >
  </app-user-documentation-form>
</ng-container>

<!--user organization Audit -->
<!-- <ng-container *ngIf="userOrganizationAuditPage">
  <app-audit [service]="UserOrganizationsService" methodName="groupPriceDetailsGetGroupPriceDetailsAudit"
    (hidePage)="onHideUserOrganizationAuditPage()">
  </app-audit>
</ng-container> -->
